import React from 'react';
import button from '../styles/Show.css';

const Show = ({ input}) => (
	<div className='input'>
		{input}
	</div>
	
);

export default Show;